<template>
  <v-layout row justify-center>
    <v-dialog
      v-model="chartAreaDialog"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <!-- <template v-slot:activator="{ on }">
        <v-btn color="primary" dark v-on="on">Open Dialog</v-btn>
      </template>-->
      <v-card>
        <v-toolbar dark color="primary">
          <v-btn icon dark @click="closeChartArea">
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title>{{titleChart ? types[titleChart].title : ''}}</v-toolbar-title>
        </v-toolbar>
        <v-list three-line subheader>
          <!-- <v-subheader class="pl-5 ml-5">Selecione os campos abaixo para gerar o gráfico</v-subheader> -->
          <v-list-tile avatar class="px-5 mx-5 mt-3">
            <!-- <v-layout row wrap> -->
            <v-flex xs5 pl-0>
              <v-select
                v-show="titleChart != 'comparative'"
                return-object
                class="listMin"
                v-model="value"
                :items="items"
                attach
                small-chips
                label="Grupos de despesas"
                multiple
              ></v-select>
              <v-select
                v-show="titleChart == 'comparative'"
                class="listMin"
                v-model="expenseGroup_id"
                item-v
                :items="items"
                item-text="name"
                item-value="expenseGroup_id"
                attach
                small-chips
                label="Grupos de despesas"
                @change="loadAccountPlans"
              ></v-select>
            </v-flex>
            <v-flex xs5 ml-5 v-if="titleChart == 'comparative'">
              <v-select
                id="comparativeReport"
                class="comparativeReportMiniChips"
                small-chips
                return-object
                v-model="accountPlansValue"
                :items="accountPlans"
                item-text="plan"
                item-value="idPlan"
                label="Selecione os planos de contas"
                multiple
              ></v-select>
            </v-flex>
            <v-flex flex xs2 pt-2 pl-1>
              <v-btn color="blue-grey" class="white--text" @click="generate">
                Gerar
                <v-icon right dark>cached</v-icon>
              </v-btn>
            </v-flex>
            <!-- </v-layout> -->
            <!-- <v-list-tile-action>
              <v-checkbox v-model="notifications"></v-checkbox>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>Notifications</v-list-tile-title>
              <v-list-tile-sub-title>Notify me about updates to apps or games that I downloaded</v-list-tile-sub-title>
            </v-list-tile-content>-->
          </v-list-tile>
        </v-list>
        <GridComparativeBudgetRealized
          :generate="loadAccountPlans"
          v-if="titleChart == 'comparative'"
          :comparativeLines="comparativeLines"
        />
        <LineChartExpensesGroups v-if="titleChart != 'comparative'" :seriesBuild="seriesBuild" />
      </v-card>
    </v-dialog>
  </v-layout>
</template>
<script>
import * as moment from "moment";
import LineChartExpensesGroups from "./LineChartExpensesGroups";
import GridComparativeBudgetRealized from "./GridComparativeBudgetRealized";
export default {
  components: {
    LineChartExpensesGroups,
    GridComparativeBudgetRealized
  },
  props: {
    queryAccountPlans: Object,
    items: Array,
    dataSeries: Array,
    openChartArea: Function,
    closeChartArea: Function,
    chartAreaDialog: Boolean,
    titleChart: String
  },
  watch: {
    accountPlansValue(val) {
      //console.log(val.length);
      this.chipSize(val.length);
    },
    chartAreaDialog(val) {
      this.seriesBuild = [];
      this.comparativeLines = [];
      this.expenseGroup_id = "";
      this.accountPlansValue = [];
      this.accountPlans = [];
      this.value = [];
      if (val) {
      }
    }
  },
  data() {
    return {
      comparativeLines: [],
      accountPlans: [],
      expenseGroup_id: "",
      types: {
        budget: { title: "Relatório de orçamento" },
        realized: { title: "Relatório realizado" },
        comparative: { title: "Relatório Comparativo" }
      },
      seriesBuild: [
        // {
        //   name: "Session Duration",
        //   data: [45, 52, 38, 24, 33, 26, 21, 20, 6, 8, 15, 10]
        // },
        // {
        //   name: "Page Views",
        //   data: [35, 41, 62, 42, 13, 18, 29, 37, 36, 51, 32, 35]
        // },
        // {
        //   name: "Total Visits",
        //   data: [87, 57, 74, 99, 75, 38, 62, 47, 82, 56, 45, 47]
        // }
      ],
      year: "",
      value: [],
      accountPlansValue: []
      //   items: ["Programming", "Design", "Vue", "Vuetify"]
    };
  },
  methods: {
    loadAccountPlans(recoverPlans) {
      let recoverIds;
      if (recoverPlans == "rec") {
        let _this = this;
        recoverIds = this.accountPlansValue.map(plan => {
          return plan.idPlan;
        });
      }
      let query = this.queryAccountPlans;
      query.expenseGroup_id = this.expenseGroup_id;
      this.accountPlansValue = [];
      this.comparativeLines = [];
      //console.log(recoverIds);

      let obj = {
        url: "/api/report/comparative",
        query: query,
        method: "post"
      };
      this.$store.dispatch("request/doRequest", obj).then(response => {
        this.accountPlans = response.data.map(line => {
          line.months.map(month => {
            month.hover = false;
            return month;
          });
          console.log("qu99999i");
          line.year = query.year;
          return line;
        });

        if (recoverPlans == "rec") {
          this.reloadAccountsPlans(recoverIds).then(_ => {
            this.generate();
          });
        }
      });
      // this.accountPlans = this.$store.state.responseTest.map(line => {
      //   line.months.map(month => {
      //     month.hover = false;
      //     return month;
      //   });
      //   return line;
      // });
    },
    async reloadAccountsPlans(recoverIds) {
      let arr = [...this.accountPlans];
      let selPlans = [];
      for (let i = 0; i < recoverIds.length; i++) {
        let selPlan = arr.filter(obj => {
          return obj.idPlan === recoverIds[i];
        });
        selPlans.push(selPlan[0]);
      }
      //console.log("pppp");
      this.accountPlansValue = await [...selPlans];
    },
    generate() {
      let arr = [];
      if (this.titleChart == "comparative") {
        this.$store.commit("showLoader", {
          circle: true
        });
        console.log(this.accountPlansValue);
        setTimeout(() => {
          this.comparativeLines = [...this.accountPlansValue];
          this.$store.commit("hideLoader");
        }, 500);
        //console.log(this.accountPlansValue);
        return;
      }
      for (let i = 0; i < this.value.length; i++) {
        //console.log(this.value[i]);
        for (let v = 0; v < this.dataSeries.length; v++) {
          if (this.value[i] == this.dataSeries[v].ref) {
            arr.push(this.dataSeries[v]);
          }
        }
      }
      this.seriesBuild = arr;
      //this.value = [];
    },
    chipSize(size) {
      let chips = document.querySelector(
        ".comparativeReportMiniChips div.v-input__control"
      );
      //if (this.accountPlansValue.length >= 2) {
      //chips.removeAttribute("class");
      //chips.classList.add("comparativeReportMiniChips");
      if (!chips) {
        return;
      }
      chips.classList.remove("size_50");
      chips.classList.remove("size_33");
      chips.classList.remove("size_25");
      chips.classList.remove("size_20");
      if (size >= 5) {
        chips.classList.add("size_20");
      }
      switch (size) {
        case 2:
          chips.classList.add("size_50");
          break;
        case 3:
          chips.classList.add("size_33");
          break;
        case 4:
          chips.classList.add("size_25");
          break;
        default:
      }
    }
    //}
  }
};
</script>

<style>
.comparativeReportMiniChips div.v-input__control .v-chip {
  max-width: 100% !important;
  overflow: hidden;
}
.comparativeReportMiniChips div.v-input__control.size_50 .v-chip {
  max-width: 48% !important;
}
.comparativeReportMiniChips div.v-input__control.size_33 .v-chip {
  max-width: 31% !important;
}
.comparativeReportMiniChips div.v-input__control.size_25 .v-chip {
  max-width: 23% !important;
}
.comparativeReportMiniChips div.v-input__control.size_20 .v-chip {
  max-width: 18% !important;
}
.listMin a {
  height: 48px !important;
}
.miniChips .v-chip {
  max-width: 75px !important;
  overflow: hidden;
}
</style>